import { EXPLICIT_DATA_TYPE_TO_FAMILY } from '../../../constants/recommendations/DataTypeFamilies';
import { pageRelevancyData } from '../../../constants/recommendations/PageRelevancyData';
import { RELEVANCY_DATA_SOURCES } from '../../../types/relevancyData';
const crmRegex = /\/contacts\/[0-9]*\/objects\/([0-9]-[0-9]*)/;
const findPageMatch = url => pageRelevancyData.find(pageData => pageData.patterns.find(pattern => pattern.test(url)));
export const getPageUrlBasedRelevancyData = pageUrl => {
  const pageMatch = findPageMatch(pageUrl);
  if (pageMatch) {
    return pageMatch.relevancyData;
  }
  const crmMatch = crmRegex.exec(pageUrl);
  if (crmMatch) {
    const objectTypeId = crmMatch[1];
    const dataTypeFamilies = EXPLICIT_DATA_TYPE_TO_FAMILY[objectTypeId];
    if (dataTypeFamilies && dataTypeFamilies.length) {
      return {
        dataTypes: dataTypeFamilies
      };
    }
    return {
      dataTypes: [objectTypeId]
    };
  }
  return undefined;
};
export const getLastPageRelevancyData = () => {
  const lastPageUrl = document.referrer;
  const relevancyData = getPageUrlBasedRelevancyData(lastPageUrl);
  return relevancyData ? Object.assign({
    dataSource: RELEVANCY_DATA_SOURCES.LAST_PAGE
  }, relevancyData) : undefined;
};
export const getPageNameBasedRelevancyData = pageName => {
  const pageMatch = pageRelevancyData.find(pageData => pageData.pageNames.includes(pageName));
  return pageMatch ? pageMatch.relevancyData : undefined;
};